import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import AcademicsView from './academics.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useAcademicsRoutes = () => {
  const academicsComponent = (
    <ProtectedRoute module="academics" checkAnySubmodule>
      <AcademicsView />
    </ProtectedRoute>
  );
  return (
    <Route path={pages.academics.path} element={academicsComponent}>
      <Route
        path={pages.academics.path + '/:academicSubRouteId'}
        element={academicsComponent}
      />
    </Route>
  );
};

export default useAcademicsRoutes;
